export const SET_LOCATION = "setLocation";
export const SET_CONTEXT_MENU_VISIBILITY = "setContextMenuVisibility";
